import { REPORT_ENDPOINT } from '../../../../../api/endpoint';
export const LOGS_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/frontdesk/logs`;
export const ROOM_MOVE_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/room-move`;
